import PictureInPicturePlayer from "./PictureInPicturePlayer";

export default PictureInPicturePlayer;
